<template>
  <div class="flex align-center justify-between solid radius sn-range-input padding-right-sm">
    <el-input :placeholder="startPlaceholder" @input="setValue($event,'sNum')"
              :value="sNum"/>
    <div class="margin-lr">{{rangeSeparator}}</div>
    <el-input :placeholder="endPlaceholder" @input="setValue($event,'eNum')"
              :value="eNum"/>
    <i class="el-icon-circle-close cursor"
       @click="clean"
       v-if="sNum || eNum"></i>
  </div>
</template>

<script>
  import ElIcon from "../../../node_modules/element-ui/packages/icon/src/icon.vue";

  export default {
    components: {ElIcon},
    props:{
      startPlaceholder:{
        type:String,
        value:''
      },
      endPlaceholder:{
        type:String,
        value:''
      },
      rangeSeparator:{
        type:String,
        value:''
      },
    },
    data () {
      return {
        sNum:'',
        eNum:'',
      }
    },
    methods:{
      init(){

      },
      clean(){
        this.sNum=''
        this.eNum=''
        this.$emit('input', '')
      },
      setValue(val,key){
        this[key]=val.replace(/[^\d]/g,'')
        console.log(arguments)
        this.$emit('input', this.sNum+'-'+this.eNum)
      },
    },
    mounted(){
      this.init()
    }
  }
</script>

<style>
  .sn-range-input{
    height: 30px;
    line-height: 30px;
    margin-top: 5px;
    width: 355px;
    box-sizing: border-box;
  }
  .sn-range-input .el-input__inner{
    border-width: 0;
  }
  .sn-range-input .el-icon-circle-close{
    position: absolute;
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/sn-range-input.vue